import React, { useState } from 'react';
import { Alert, Button, Divider, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GrowRegistrationStatusOut } from '../../api';
import { GrowConnectCard } from './GrowConnectCard';
import { GrowFormLink } from './GrowFormLink';
import { GrowConnectForm } from './GrowConnectForm';

type GrowConnectPendingProps = {
  registration: GrowRegistrationStatusOut;
  onRegistered: () => Promise<unknown>;
  onStale: () => Promise<unknown>;
};

export const GrowConnectPending = ({ registration, onRegistered, onStale }: GrowConnectPendingProps) => {
  const { t } = useTranslation();
  const [isResendOpen, setIsResendOpen] = useState(false);

  return (
    <GrowConnectCard title={t('growConnect.pending.title')}>
      <Typography textAlign="center">
        {t('growConnect.pending.smsSentTo')}{' '}
        <Typography component="span" dir="ltr" fontWeight={700}>
          {registration.phone}
        </Typography>
      </Typography>

      <Typography>{t('growConnect.pending.fillFromThatPhone')}</Typography>

      <GrowFormLink formUrl={registration.form_url} />

      {registration.message && (
        <Alert severity="info">
          <Typography fontSize="13px" fontWeight={700}>
            {t('growConnect.pending.growUpdateLabel')}
          </Typography>
          <Typography>{registration.message}</Typography>
        </Alert>
      )}

      <Divider />

      <Typography>{t('growConnect.pending.reviewExpectation')}</Typography>

      <Grid container flexDirection="column" gap={1}>
        <Typography fontWeight={700}>{t('growConnect.pending.wrongNumberTitle')}</Typography>
        <Typography>{t('growConnect.pending.wrongNumberBody')}</Typography>
        {isResendOpen && registration.business_number ? (
          <GrowConnectForm
            isResend
            initialBusinessNumber={registration.business_number}
            onRegistered={onRegistered}
            onStale={onStale}
          />
        ) : (
          <Grid container justifyContent="center" mt={1}>
            <Button variant="outlined" onClick={() => setIsResendOpen(true)}>
              {t('growConnect.pending.wrongNumberCta')}
            </Button>
          </Grid>
        )}
      </Grid>

      <Divider />

      <Typography color="text.secondary" fontSize="13px" textAlign="center">
        {t('growConnect.pending.stuckContactSupport')}
      </Typography>
    </GrowConnectCard>
  );
};
